import { Tag } from '@playq/octopus-common';

export const isTagsEqual = (t1: Tag, t2: Tag): boolean => t1.key === t2.key && t1.value === t2.value;
